/**
 * User Behavior Tracking API
 * 
 * Handles all API calls for tracking user behavior including:
 * - Page views
 * - Time spent on pages
 * - Navigation flow
 */

import apiClient from '../shared/services/apiClient';

export const userBehaviorTrackingAPI = {
  /**
   * Track a page view
   * @param {Object} data - Tracking data
   * @param {string} data.session_id - Unique session identifier
   * @param {string} data.page_path - The route path
   * @param {string} data.page_name - Human-readable page name
   * @param {string} data.previous_page_path - Previous page path
   * @param {string} data.user_agent - Browser user agent
   * @param {string} data.referrer - HTTP referrer
   * @param {number} data.screen_width - Screen width
   * @param {number} data.screen_height - Screen height
   */
  trackPageView: (data) => {
    return apiClient.post('/user-behavior-tracking/page-view', data);
  },

  /**
   * Update time spent on current page
   * @param {Object} data - Update data
   * @param {string} data.session_id - Session identifier
   * @param {string} data.page_path - Current page path
   * @param {number} data.time_spent_seconds - Time spent in seconds
   */
  updateTimeSpent: (data) => {
    return apiClient.put('/user-behavior-tracking/update-time', data);
  },

  /**
   * Track page exit
   * @param {Object} data - Exit data
   * @param {string} data.session_id - Session identifier
   * @param {string} data.page_path - Page being exited
   * @param {string} data.next_page_path - Next page path
   */
  trackPageExit: (data) => {
    return apiClient.put('/user-behavior-tracking/page-exit', data);
  },

  /**
   * Get user's behavior tracking data
   * @param {Object} params - Query parameters
   */
  getTrackingData: (params = {}) => {
    return apiClient.get('/user-behavior-tracking', { params });
  },

  /**
   * Get analytics summary
   * @param {Object} params - Query parameters (start_date, end_date)
   */
  getAnalytics: (params = {}) => {
    return apiClient.get('/user-behavior-tracking/analytics', { params });
  }
};

export default userBehaviorTrackingAPI;

